export function getValidAiQueryLimit(limit, maxLimit) {
    if (!limit) {
        return maxLimit;
    }
    return Math.min(limit, maxLimit);
}
//# sourceMappingURL=validators.js.map